<template>
	<section class="content">
		<v-slide-x-transition mode="out-in">
	    <router-view></router-view>
	  </v-slide-x-transition>
  </section> 
</template>

<script>
export default {
	name: 'Reports'
}
</script>


// WEBPACK FOOTER //
// src/components/reports/index.vue